module.exports = __webpack_public_path__ + "img/Retail21.7c1b2836.png";